import { useCallback } from 'react';
import type { Command } from '@atlassian/jira-command-palette';
import { useChildCommandActions } from '../child-commands';

export function useSubscribeChildCommands() {
	const { addChildCommands, removeChildCommands } = useChildCommandActions();

	const subscribe = useCallback(
		(commands: Command[]) => {
			addChildCommands(commands);
			return () => {
				removeChildCommands(commands);
			};
		},
		[addChildCommands, removeChildCommands],
	);

	return subscribe;
}
